import { render, staticRenderFns } from "./audio-text.vue?vue&type=template&id=011ee8ba&"
import script from "./audio-text.vue?vue&type=script&lang=js&"
export * from "./audio-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports